{
  "generic": {
    "no": "Nu",
    "yes": "Da",
    "text": "Text "
  },
  "consent": {
    "defaultLabelText": "Trimițând acest formular, sunteți de acord cu ",
    "defaultLabelLink": "politica de confidențialitate"
  },
  "text": {
    "defaultHeadlineText": "Acesta este un titlu",
    "defaultText": "Acesta este un bloc de text",
    "floatingDefaultText": "NOU!"
  },
  "button": {
    "submitDefaultText": "Trimite",
    "instagramDefaultText": "Urmăriți-ne",
    "defaultText": "Faceți clic aici",
    "closing": "ÎNCHIDERE..."
  },
  "input": {
    "emailLabel": "E-mail",
    "emailPlaceholder": "Introduceți e-mailul dvs.",
    "passwordLabel": "Parolă",
    "passwordPlaceholder": "Introduceți parola",
    "nameLabel": "Nume",
    "namePlaceholder": "Introduceți numele dvs.",
    "firstNameLabel": "Prenume",
    "firstNamePlaceholder": "Introduceți prenumele",
    "lastNameLabel": "Nume de familie",
    "lastNamePlaceholder": "Introduceți numele de familie",
    "phoneLabel": "Telefon",
    "phonePlaceholder": "Introduceți numărul de telefon",
    "textareaLabel": "Mesaj",
    "textareaPlaceholder": "Introduceți mesajul dvs.",
    "regularLabel": "Text",
    "regularPlaceholder": "Introduceți text",
    "defaultLabel": "Etichetă",
    "defaultPlaceholder": "Substituent",
    "datePlaceholder": "Selectați data",
    "stepLabel": "Introduceți întrebarea dvs. aici"
  },
  "dropdown": {
    "placeholder": "Selectați o opțiune",
    "firstItem": "Opțiunea 1",
    "secondItem": "Opțiunea 2",
    "chooseCountry": "Țară"
  },
  "buttonList": {
    "firstItem": "Opțiunea 1",
    "secondItem": "Opțiunea 2",
    "option1": "Alegere 1",
    "option2": "Alegere 2",
    "option3": "Alegere 3",
    "subscriptionItem1": "Buletin informativ",
    "subscriptionItem2": "Actualizări",
    "chooseSubscriptionTopics": "Alegeți subiecte de abonament",
    "other": "Altul",
    "uncheck-all-label": "Nu doresc să primesc niciunul dintre aceste e-mailuri"
  },
  "rating": {
    "rateLabel": "Evaluați-ne",
    "npsLabel": "Cât de probabil este să ne recomandați?",
    "veryUnsatisfied": "Foarte nemulțumit",
    "unsatisfied": "Nemulțumit",
    "neutral": "Neutru",
    "satisfied": "Mulțumit",
    "loveIt": "Îmi place!",
    "minValueLabel": "Scăzut",
    "maxValueLabel": "Ridicat",
    "minValueLabelNps": "Puțin probabil",
    "maxValueLabelNps": "Foarte probabil"
  },
  "deadline": {
    "days": "Zile",
    "hours": "Ore",
    "minutes": "Minute",
    "seconds": "Secunde"
  },
  "bulletList": {
    "firstItem": "Beneficiu 1",
    "secondItem": "Beneficiu 2"
  },
  "discountCode": {
    "copyMessage": "Copiat în clipboard!",
    "fallback": "WELCOME10",
    "textDefault": "Codul dvs. de reducere",
    "buttonDefault": "Copiază"
  },
  "share": {
    "buttonText": "Distribuie"
  },
  "common": {
    "label": "Etichetă"
  },
  "wcag": {
    "banner": "Banner promoțional",
    "closeButton": "Închide",
    "submitButton": "Trimite formular"
  },
  "spinTheWheel": {
    "prizeWonText": "Felicitări!",
    "prizeWonButtonText": "Revendicați premiul",
    "prizeLostText": "Ohhh, ce păcat! :-(",
    "prizeLostButtonText": "Faceți clic pentru a închide",
    "spinButtonLabel": "ROTEȘTE"
  },
  "memory": {
    "resultWonText": "Bună treabă! Timpul dvs. a fost {elapsedTime}",
    "resultWonButtonText": "Revendicați premiul"
  },
  "stepNavigation": {
    "nextButtonText": "Următorul",
    "previousButtonText": "Anterior",
    "lastButtonText": "Închide",
    "submitButtonText": "Trimite"
  },
  "defaultRealTimeMessage": {
    "validationError": "Vă rugăm să verificați formatul datelor trimise.",
    "unknownError": "A apărut o problemă neașteptată la trimitere.",
    "conflictError": "Acest utilizator există deja.",
    "success": "Formular trimis."
  }
}
